__webpack_require__.p = "https://smartclinic-preprod.curebay.in/";